import { Helmet, HelmetProvider } from "react-helmet-async";

const TermsCondition = () => {
 
  return (
    <div className="h-screen flex w-full">
      <HelmetProvider>
        <Helmet>
          <title>Simplyenglish AI | Terms & Conditions </title>
        </Helmet>
      </HelmetProvider>

      <div className=" flex align-center h-screen w-full">
        <div className=" w-full bg-white p-5 content-container">
          <p><strong>Terms & Conditions for Simply English AI Tutor App</strong></p>
          <p>Effective Date: 20-Sep-23</p>
          <p><strong>1. Acceptance of Terms</strong></p>

          <p>Welcome to the Simply English AI Tutor App (referred to as &quot;the App&quot;). These Terms and Conditions (&quot;Terms&quot;) govern your use of the App and the services provided through it. By accessing or using the App, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the App.</p>

          <p><strong>2. Use of the App</strong></p>

          <p>2.1. <strong>User Eligibility:</strong> You must be at least 18 years old to use the App. If you are under 18, you may only use the App with the consent and supervision of a parent or legal guardian.</p>

          <p>2.2. <strong>Account Registration:</strong> To access certain features of the App, you may be required to register for an account. You are responsible for providing accurate and up-to-date information during the registration process and for keeping your login credentials secure.</p>

          <p>2.3. <strong>Prohibited Activities:</strong> You agree not to:</p>

          <p>Use the App for any illegal or unauthorized purpose.</p>

          <p>Impersonate any person or entity.</p>

          <p>Attempt to gain unauthorized access to the App or its related systems.</p>

          <p>3. <strong>Content</strong></p>

          <p>3.1. <strong>User Content:</strong> The App may allow you to submit content such as questions, answers, or comments (&quot;User Content&quot;). By submitting User Content, you grant the App a worldwide, non-exclusive, royalty-free, transferable license to use, display, and distribute your User Content.</p>

          <p>3.2. <strong>Content Ownership:</strong> All content provided through the App, including but not limited to text, graphics, and software, is owned by or licensed to Simply English. You may not copy, modify, or distribute any content from the App without prior written consent.</p>

          <p>4. <strong>Privacy</strong></p>

          <p>Your use of the App is subject to our Privacy Policy, which can be found [insert link to Privacy Policy]. By using the App, you consent to the collection and use of your personal information as described in the Privacy Policy.</p>

          <p>5. <strong>Termination</strong></p>

          <p>Simply English reserves the right to terminate or suspend your account and access to the App at its sole discretion, with or without cause, and without notice.</p>

          <p>6. <strong>Disclaimers</strong></p>

          <p>6.1. <strong>No Guarantees:</strong> The Simply English App provides educational content and assistance, but we do not guarantee the accuracy, completeness, or effectiveness of the information provided. Users are responsible for verifying the information and using their judgment.</p>

          <p>6.2. <strong>No Professional Advice:</strong> The Simply English App is not a substitute for professional advice or services. Consult with qualified professionals for specific advice or concerns.</p>

          <p>7. <strong>Limitation of Liability</strong></p>

          <p>To the fullest extent permitted by applicable law, SimplyEnglish shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.</p>

          <p>8. <strong>Changes to Terms</strong></p>

          <p>Simply English reserves the right to update or modify these Terms at any time. Changes will be effective upon posting the updated Terms on the App. Continued use of the App after such changes constitutes your acceptance of the updated Terms.</p>

          <p>9. <strong>Contact Information</strong></p>

          <p>If you have any questions or concerns about these Terms or the Simply English App, you may contact us at info@simplyenglish.ai.</p>

          <p>By using the Simply English AI Tutor App, you acknowledge that you have read, understood, and agree to these Terms and Conditions.</p>

          <p>Last updated: 20-Sep-23</p>

        </div>
      </div>
    </div>
  );
};

export default TermsCondition;
